var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StyledSwitch } from "./AppSwitch.styles";
var AppSwitch = function (props) { return (_jsx("div", __assign({ style: props.disabled ? { opacity: 0.5 } : {} }, { children: _jsx(StyledSwitch, __assign({ disableRipple: true }, props)) }))); };
export { AppSwitch };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwU3dpdGNoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvdWkvQXBwU3dpdGNoL0FwcFN3aXRjaC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQ0EsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLG9CQUFvQixDQUFDO0FBRWxELElBQU0sU0FBUyxHQUFHLFVBQUMsS0FBa0IsSUFBa0IsT0FBQSxDQUNyRCx1QkFBSyxLQUFLLEVBQUUsS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRSxPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsZ0JBQ2hELEtBQUMsWUFBWSxhQUFDLGFBQWEsVUFBSyxLQUFLLEVBQUksSUFDckMsQ0FDUCxFQUpzRCxDQUl0RCxDQUFDO0FBRUYsT0FBTyxFQUFFLFNBQVMsRUFBRSxDQUFDIn0=